<template>
  <div>
    <dialog-popup
      :dialog="value"
      @dialogItem="renamePosition($event)"
      @back="emit('input', false)"
      @clearApiError="emit('clearError')"
      :label="'Position'"
      ghostText="Rename"
      :type="type"
      :buttonLabel="$loader.isAppLoading ? 'Saving' : 'Save'"
      :breakDescription="false"
      :allowSpecialCharacters="true"
      :isShowCharCounter="true"
      :maxWidth="'665'"
      :orgObjectType="'position'"
      :apiError="errorMessage"
      :duplicateNotAllowed="false"
      :placeholder="name"
      :max_char="90"
    />
  </div>
</template>

<script setup>
import DialogPopup from '@components/Modal/DialogPopup.vue';
const props = defineProps({
  type: {
    type: String,
    required: false,
  },
  value: {
    type: Boolean,
    default: false,
  },
  errorMessage: {
    type: String,
    default: ''
  },
  name: {
    type: String,
    default: ''
  }
});

const emit = defineEmits(['input', 'clearError', 'onSave']);

const renamePosition = (position) => {
  emit("onSave", position);
};
</script>